import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {AlertPosition, AlertType} from "../../../constants/AppConstants";
import {AlertModel} from "../../../models/AlertModel";

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  toggleAlert: Subject<AlertModel> = new Subject();

  /**
   * Show Alert Message
   *
   * @param title 'message to display'
   * @param description 'message to display'
   * @param message 'message to display'
   * @param variant 'variant to display'
   * @param position 'position to display'
   * @param timeout 'timeout to hide'
   */
  showAlert(
    title?: string,
    description?: string,
    message?: string,
    variant?: AlertType,
    position?: AlertPosition,
    timeout?: number
  ): void {
    this.toggleAlert.next({
      title: title ?? '',
      description: description ?? '',
      variant: variant ?? AlertType.ERROR,
      message: message ?? '',
      position: position ?? AlertPosition.TOP_RIGHT,
      timeout: timeout ?? 5000,
    });
  }
}
